import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 2110. ダッシュボード（取引先別ランキング）
 * [GET] /workspaces/:identifier/dashboard/amount_by_business_partner
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  product_ids?: number[];
  sales_context_ids?: number[];
};

export type DashboardAmountByBusinessPartner = {
  total_amount: number;
  business_partner_rankings: { name: string; total_amount: number; contracted_amount: number }[];
};

const dashboardAmountByBusinessPartner = (props: Props): Promise<DashboardAmountByBusinessPartner> => {
  return axios.get(`/api/workspaces/${props.identifier}/dashboard/amount_by_business_partner`, { params: props });
};

export const useDashboardAmountByBusinessPartner = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'dashboard', 'amount_by_business_partner', { ...props }],
    queryFn: () => dashboardAmountByBusinessPartner(props),
    staleTime: 1000 * 60 * 30,
  });
};
